const generateUniquePageMetaValue = (pages, value, key) => {
  const copiedValuePrefix = `${value}-`;
  let newIndex = 0;

  return pages.reduce((newValue, page) => {
    if (page[key] === value) {
      return newValue.startsWith(copiedValuePrefix) ? newValue : `${copiedValuePrefix}2`;
    }

    if (!page[key].startsWith(copiedValuePrefix)) return newValue;

    const valueIndex = Number(page[key].replace(copiedValuePrefix, ''));

    if (!valueIndex || newIndex > valueIndex + 1) {
      return newValue;
    }

    newIndex = valueIndex + 1;

    return `${copiedValuePrefix}${newIndex}`;
  }, value);
};

const generateUniquePageTitle = (pages, value) =>
  generateUniquePageMetaValue(pages, value, 'title');
const generateUniquePageName = (pages, value) => generateUniquePageMetaValue(pages, value, 'name');

export { generateUniquePageTitle, generateUniquePageName };
export default generateUniquePageMetaValue;
